export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10350.39f20cea.jpg";